import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import { useTranslation } from '../i18n';
import './Legal.css';

const Privacy = () => {
  const { t } = useTranslation();
  const business = process.env.REACT_APP_BUSINESS || 'SeekWebs';
  const domain = process.env.REACT_APP_DOMAIN || 'seekwebs.com.br';
  const email = process.env.REACT_APP_EMAIL || 'contato@seekwebs.com.br';
  const businessName = process.env.REACT_APP_BUSINESS_NAME || 'CRF DIGITAL MARKETING LTDA';
  const cnpj = process.env.REACT_APP_CNPJ || '44.230.574/0001-21';
  const street = process.env.REACT_APP_STREET || 'RUA SEBASTIAO DA ROCHA PITA, 120';
  const neighborhood = process.env.REACT_APP_NEIGHBORHOOD || 'JARDIM SANTA GENEBRA';
  const city = process.env.REACT_APP_CITY || 'SAO PAULO';
  const state = process.env.REACT_APP_STATE || 'SP';
  const zipcode = process.env.REACT_APP_ZIPCODE || '13.080-300';

  const dataCollectionItems = t('privacy.sections.dataCollection.items');
  const legalBasisItems = t('privacy.sections.legalBasis.items');
  const dataUsageItems = t('privacy.sections.dataUsage.items');
  const dataSharingItems = t('privacy.sections.dataSharing.items');
  const rightsItems = t('privacy.sections.rights.items');

  return (
    <>
      <Helmet>
        <title>{t('privacy.title')} - {business}</title>
        <meta name="description" content={`${t('privacy.title')} - ${business}`} />
      </Helmet>

      <div className="legal-container">
        <motion.header
          className="legal-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Link to="/" className="back-link">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12 16L6 10L12 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {t('common.backToHome')}
          </Link>
        </motion.header>

        <motion.main
          className="legal-content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h1>{t('privacy.title')}</h1>
          <p className="last-update">{t('privacy.lastUpdate')}</p>

          <section>
            <h2>{t('privacy.sections.responsible.title')}</h2>
            <p>{t('privacy.sections.responsible.intro', { domain })}</p>
            <div className="company-details">
              <p><strong>{businessName}</strong></p>
              <p>CNPJ: {cnpj}</p>
              <p>{street}, {neighborhood}</p>
              <p>{city} - {state} - CEP: {zipcode}</p>
              <p>Email: {email}</p>
            </div>
          </section>

          <section>
            <h2>{t('privacy.sections.dataCollection.title')}</h2>
            <p>{t('privacy.sections.dataCollection.intro', { business })}</p>
            <ul>
              {Array.isArray(dataCollectionItems) && dataCollectionItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2>{t('privacy.sections.legalBasis.title')}</h2>
            <p>{t('privacy.sections.legalBasis.intro')}</p>
            <ul>
              {Array.isArray(legalBasisItems) && legalBasisItems.map((item, index) => (
                <li key={index}><strong>{item.type}</strong> {item.description}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2>{t('privacy.sections.dataUsage.title')}</h2>
            <p>{t('privacy.sections.dataUsage.intro')}</p>
            <ul>
              {Array.isArray(dataUsageItems) && dataUsageItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2>{t('privacy.sections.dataSharing.title')}</h2>
            <p>{t('privacy.sections.dataSharing.intro')}</p>
            <ul>
              {Array.isArray(dataSharingItems) && dataSharingItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2>{t('privacy.sections.cookies.title')}</h2>
            <p>{t('privacy.sections.cookies.content')}</p>
          </section>

          <section>
            <h2>{t('privacy.sections.security.title')}</h2>
            <p>{t('privacy.sections.security.content')}</p>
          </section>

          <section>
            <h2>{t('privacy.sections.rights.title')}</h2>
            <p>{t('privacy.sections.rights.intro')}</p>
            <ul>
              {Array.isArray(rightsItems) && rightsItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p>{t('privacy.sections.rights.contact', { email })}</p>
          </section>

          <section>
            <h2>{t('privacy.sections.retention.title')}</h2>
            <p>{t('privacy.sections.retention.content')}</p>
          </section>

          <section>
            <h2>{t('privacy.sections.minors.title')}</h2>
            <p>{t('privacy.sections.minors.content', { business })}</p>
          </section>

          <section>
            <h2>{t('privacy.sections.internationalTransfer.title')}</h2>
            <p>{t('privacy.sections.internationalTransfer.content')}</p>
          </section>

          <section>
            <h2>{t('privacy.sections.policyChanges.title')}</h2>
            <p>{t('privacy.sections.policyChanges.content')}</p>
          </section>

          <section>
            <h2>{t('privacy.sections.contactDPO.title')}</h2>
            <p>{t('privacy.sections.contactDPO.intro')}</p>
            <p>{t('privacy.sections.contactDPO.email', { email })}</p>
            <p>{t('privacy.sections.contactDPO.address', { street, neighborhood, city, state, zipcode })}</p>
          </section>
        </motion.main>
      </div>
    </>
  );
};

export default Privacy;
